import { useQuery, type UseQueryResult } from 'react-query';
import {
  WarrantSharedService,
  type Wealthlane_CapTable_Dtos_Common_LatestAndPriorStockData,
} from '@wealthlane/api-services/wealthlane-captable-service';

const useGetWarrantCurrentFMV = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  enabled: boolean = true
): UseQueryResult<Wealthlane_CapTable_Dtos_Common_LatestAndPriorStockData | undefined, unknown> => {
  return useQuery(
    ['getWarrantCurrentFMV'],
    async () => {
      return await handleRequest(
        WarrantSharedService.getApiCapTableApiAppWarrantSharedCurrentFMv()
      );
    },
    { enabled }
  );
};

export default useGetWarrantCurrentFMV;
